module.exports = __webpack_public_path__ + "img/punga-accommodation.820e98e2.webp";